import { Box, Flex, Text } from '@chakra-ui/react';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText, OutlineCard } from '@morressier/alembic';

import { Layout } from 'src/components/Layout';
import { Overlay } from 'src/components/Overlay';
import { IGetRevisionHistory } from '@publishing-engine/submission-service/src/endpoints/api.response-types';
import PastReviewRevisionOverviewContent from 'src/components/PastReviewHistory/PastReviewRevisionOverviewContent';
type IProps = {
  round: IGetRevisionHistory;
  onClose: () => void;
  submissionContextId?: string;
};
const PastReviewModal: React.FC<IProps> = ({ round, onClose, submissionContextId }) => {
  return (
    <>
      <Overlay>
        <Layout width="50%">
          <Flex gap={3} flexDirection="column" justifyContent="start">
            <ButtonText
              leftIcon={<FontAwesomeIcon icon={faArrowLeft} />}
              maxWidth="fit-content"
              onClick={onClose}
            >
              {'Back to Past Reviews'}
            </ButtonText>
            <Box marginBottom={3} marginTop={2}>
              <Text textStyle="headingSection" id="review-history">
                Your Past Review
              </Text>
            </Box>
            <OutlineCard padding={4} borderStyle={'none'} borderRadius={'none'}>
              <PastReviewRevisionOverviewContent revision={round} submissionContextId={submissionContextId} />
            </OutlineCard>
          </Flex>
        </Layout>
      </Overlay>
    </>
  );
};

export default PastReviewModal;
